// extracted by mini-css-extract-plugin
export default {"imageOverlay":"style_imageOverlay__MGL3v"};